import React from 'react';

// Component Styles
import './mobileLinks.scss';
import AppConfiguration from '../../../services/AppConfiguration';

export default function mobileLinks() {
  const appConfig = AppConfiguration.getConfig();
  return (
    <div className='wtfMobileLinks'>
      <span>Get our mobile app to identify fonts with your camera!</span>
      <div className='wtfMobileLinks_badgesWrapper'>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://itunes.apple.com/us/app/whatthefont/id304304134?mt=8'
        >
          <img src={`${appConfig.cdnUrl.url}/app-store-badge.svg`} alt='App Store badge' />
        </a>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://play.google.com/store/apps/details?id=com.monotype.whatthefont'
        >
          <img src={`${appConfig.cdnUrl.url}/google-play-badge.png`} alt='Google Play Store badge' />
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/MobileLinks/MobileLinks.js